import MDEditor from 'components/interaction/MDEditor/index.jsx';
import Attachments from 'components/interaction/AddFiles/Attachments.jsx';
import { CONVERSATION_MAX_LENGTH } from '../constants.jsx';

import messages from '../messages.js';

const schema = {
  id: 'conversations-message',
  properties: [
    {
      id: 'body',
      as: MDEditor,
      placeholder: messages.message,
      validate: (v) => !v || v.length < CONVERSATION_MAX_LENGTH,
      attributes: { maxLength: CONVERSATION_MAX_LENGTH, autoFocus: true },
      required: true,
    },
    {
      id: 'files',
      as: Attachments,
    },
  ],
};

export default schema;
